import * as React from 'react';
import { useSelector } from 'react-redux';

import { CHATBOT_ID } from '../constants/chatbotId';
import { currentOpenChatSelector, selectChats, userIdSelector } from '../selectors';
import { IUserInChatListSchema } from '../types/userData';
import { formatCompanionData } from '../utils/formatCompanionData';

export const useCurrentChatCompanionData = (chatId?: string) => {
  const userId = useSelector(userIdSelector);
  const chats = useSelector(selectChats);
  const {
    chatId: currentOpenChatId,
    frameCompanion,
    users: currentOpenChatUsers,
  } = useSelector(currentOpenChatSelector) || {};

  const isActiveChat = chatId === currentOpenChatId;

  const chatUsers = React.useMemo(() => {
    if (isActiveChat) {
      return (currentOpenChatUsers as IUserInChatListSchema[]) || [];
    }

    const chat = chats?.find(chat => chat.chatId === chatId);

    return (chat?.users as IUserInChatListSchema[]) || [];
  }, [isActiveChat, chats, chatId, currentOpenChatUsers]);

  const companion = React.useMemo(() => {
    const opponent = chatUsers.find(user => user.chatRole === 'opponent');
    const initiator = chatUsers.find(user => user.chatRole === 'initiator');
    const companion = chatUsers.find(user => user.chatRole === 'companion');

    if (chatId === CHATBOT_ID) {
      return frameCompanion;
    }

    // Если зашли за инициатора - показываем оппонента, если его нет - компаньона
    if (initiator?.userId === userId) {
      return opponent || companion;
    }

    // Если зашли за оппонента - показываем инициатора
    if (opponent?.userId === userId) {
      return initiator;
    }

    // Если чат iframe
    if (isActiveChat && frameCompanion) {
      return frameCompanion;
    }

    // Если зашли за другого участника - показываем инициатора
    return initiator;
  }, [isActiveChat, chatUsers, chatId, frameCompanion, userId]);

  return React.useMemo(() => formatCompanionData(companion ?? ({} as IUserInChatListSchema)), [companion]);
};
